import React__default from 'react';
import PropTypes from 'prop-types';
import { n as nodeOrStringProp } from './PropTypes-e1e509ba.js';
import { I as Icon } from './index-11bc5ac3.js';
import 'moment';
import './_commonjsHelpers-17042db9.js';

function SearchBarItem(props) {
  var className = props.className,
    label = props.label,
    onClick = props.onClick,
    content = props.content,
    children = props.children,
    hasInput = props.hasInput,
    renderType = props.renderType;
  var placeholderClass = renderType === 'flexi' ? 'bf-search-bar-item-flexi' : '';
  var contentClass = renderType === 'flexi' ? '' : 'bf-search-bar-content';
  return renderType === 'flexi' ? /*#__PURE__*/React__default.createElement("div", {
    className: "bf-search-bar-item dates-placeholder ".concat(className, " ").concat(hasInput ? 'has-input' : '', " ").concat(placeholderClass)
  }, /*#__PURE__*/React__default.createElement(Icon, {
    name: "bf-icon-calendar-days search-bar-icon-custom-class",
    size: "large"
  }), /*#__PURE__*/React__default.createElement("div", {
    onClick: onClick
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "bf-search-bar-item-label"
  }, label), /*#__PURE__*/React__default.createElement("div", {
    className: contentClass
  }, content || children))) : /*#__PURE__*/React__default.createElement("div", {
    className: "bf-search-bar-item ".concat(className, " ").concat(hasInput ? 'has-input' : '', " ").concat(placeholderClass),
    onClick: onClick
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "bf-search-bar-item-label"
  }, label), /*#__PURE__*/React__default.createElement("div", {
    className: contentClass
  }, content || children));
}
SearchBarItem.defaultProps = {
  className: '',
  content: '',
  children: '',
  hasInput: false,
  renderType: 'default'
};
SearchBarItem.propTypes = {
  className: PropTypes.string,
  label: nodeOrStringProp.isRequired,
  onClick: PropTypes.func.isRequired,
  content: nodeOrStringProp,
  children: nodeOrStringProp,
  hasInput: PropTypes.bool,
  renderType: PropTypes.string
};

export default SearchBarItem;
//# sourceMappingURL=SearchBarItem.js.map
